module.exports = __webpack_public_path__ + "assets/img/en.c22e6f33.svg";